import { render, staticRenderFns } from "./RepresentingTable.vue?vue&type=template&id=54dec048&scoped=true&"
import script from "./RepresentingTable.vue?vue&type=script&lang=ts&"
export * from "./RepresentingTable.vue?vue&type=script&lang=ts&"
import style0 from "./RepresentingTable.vue?vue&type=style&index=0&id=54dec048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dec048",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VForm,VRow,VSpacer})
